/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Address from '../Address'
// import NewAddress from '../NewAddress'
import EditAddress from '../EditAddress'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/addresses',
    name: 'address',
    component: Address,
    beforeEnter: auth.requireAuth
  },
  // {
  //   path: '/addresses/create',
  //   name: 'create-address',
  //   component: NewAddress,
  //   beforeEnter: auth.requireAuth
  // },
  {
    path: '/addresses/edit/:id',
    name: 'edit-address',
    component: EditAddress,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/address/routes/index.js